module.exports = __webpack_public_path__ + "img/сard-close.cc7a5229.svg";